import { render } from "./VPhotoSwipe.vue?vue&type=template&id=543d8318"
import script from "./VPhotoSwipe.vue?vue&type=script&lang=js"
export * from "./VPhotoSwipe.vue?vue&type=script&lang=js"

import "photoswipe/dist/photoswipe.css?vue&type=style&index=0&lang=css"
import "photoswipe/dist/default-skin/default-skin.css?vue&type=style&index=1&lang=css"
import "./VPhotoSwipe.vue?vue&type=style&index=2&id=543d8318&lang=postcss"
script.render = render

export default script